import * as XState from "xstate";
import cabri from "../../app/cabri-app";
import {Point} from "../../geom-objects/point";
import {LOG} from '../../app/log'


let gesture = cabri.gestureHandler;
let movedObject= null;
const Direction = {VERTICAL: "VERTICAL", HORIZONTAL: "HORIZONTAL"};
let bindingObjects =  null;
let permanent =false;
let movingDirection = Direction.HORIZONTAL;

if (typeof (window) !== "undefined") window.XState = XState;

const states = {
    selected: {
        always: [ // direct jump depending on the device type
            {
                cond: "noMouse",
                target: "available_but_invisible",
            },
            {
                cond: "mouseIsOnObject",
                target: "rollover_movable",
            },
            {
                target: "rollover_nothing",
            },
        ],
    },
    available_but_invisible: {
        on: {
            STARTCREATE: {
                actions: ["start"],
                target: "point_created",
            },
            CANCEL: { target: "inactive" }
        },
    },
    rollover_nothing: {
        on: {
            STARTCREATE: {
                actions: ["start"],
                target: "point_created",
            },
            MEET: {
                actions: ["highlight"],

            },
            CANCEL: { actions: ["unhighlight"],
                target: "inactive" }
        },
    },
    rollover_movable: {
        on: {
            LEAVE: {
                actions: ["unhighlight"],
                target: "rollover_nothing",
            },
            STARTCREATE: {
                actions: ["start"],
                target: "point_created"
            },
            CANCEL: { actions: ["unhighlight"],
                target: "inactive" }
        },
    },
    point_created: {
        always: [ // auto-jump depending on pressed keys
            {
                cond: () => {
                    console.log("Should? " + !gesture.shouldMoveVertically)
                    return !gesture.shouldMoveVertically
                },
                target: "point_moving_horizontal",
            },
            {
                cond: () => {
                    console.log("Should? " + gesture.shouldMoveVertically)
                    return gesture.shouldMoveVertically
                },
                target: "point_moving_vertical",
            },
        ],
    },
    point_moving_horizontal: {
        on: {
            MOVE: {target: undefined, actions: ["updateCoordinateH"]},
            CANCEL: {target: "have_operated", actions: ["cancel"]},
            CHANGE_DIR: {target: "point_moving_vertical"},
            DROP: {target: "have_operated", actions: ["dropped"]},
        },
    },

    point_moving_vertical: {
        on: {
            MOVE: {target: undefined, actions: ["updateCoordinateV"]},
            CANCEL: {target: "have_operated", actions: ["cancel"]},
            CHANGE_DIR: {target: "point_moving_horizontal"},
            DROP: {target: "have_operated", actions: ["dropped"]},
        },
    },

    have_operated: {
        always: [
            {cond: "isPermanent", target: "selected"},
            {cond: undefined, target: "inactive"},
        ],
    },

    inactive: {
        on: {
            ACTIVATE: {target: "selected", actions: ["initGestures"]},
        },
    },

};



function updateCoords(o) {
    if ( o.getCoords && o.updateFromPeer) {
        o.updateFromPeer();
        const c = o.getCoords();
        console.log("Update coords " + c[0] + " " + c[1] + " " + c[2]);
        cabri.lastPointerCoord = {x: c[0], y:c[1], z:c[2]};
        cabri.notifyFileDirty();
    }
}
export default XState.Machine({
        id: "createpoint_tool",
        initial: "inactive",
        context: {
        },
        states: states,
    },
    {
        actions: {

            start: function (ctx, evt) {
                LOG.for("createpoint-tool-state") && LOG.info("Start create point.");
                let p = evt.pointerInfo.pickInfo.pickedPoint;
                const point = movedObject = new Point(p.x, p.z, p.y);
                if (bindingObjects) {
                    let acceptRelation = true;
                    for(let related of bindingObjects)
                        acceptRelation = acceptRelation && related.canBeRelatedWith(point);
                    if (acceptRelation) {
                        let rels = [];
                        for(let related of bindingObjects)
                            rels.push(related.createRelationWith(point));
                        ctx.relations = rels;
                        console.log("Rels: ", rels);
                    }
                }
                // TODO: mark temporary
            },

            highlight: function ( ctx, evt) {
                LOG.for("createpoint-tool-state") && LOG.info("Highlight ", evt.touchedGeomObject);
                if(bindingObjects) {
                    let found = false;
                    console.log("bindingObjects ", bindingObjects);
                    bindingObjects.forEach((it) => found = found || it === evt.touchedGeomObject);
                    if (!found)
                        bindingObjects.push(evt.touchedGeomObject);
                } else {
                    bindingObjects = [evt.touchedGeomObject];
                }
            },

            unhighlight: function (ctx, evt) {
                LOG.for("createpoint-tool-state") && LOG.info("Unhighlight.");
                bindingObjects = null;
            },

            dropped: function (ctx, evt) {
                LOG.for("createpoint-tool-state") && LOG.info("Dropped.");
                if (typeof (window) !== "undefined") window.cp = {movedObject:movedObject, bindingObjects: bindingObjects, relations:ctx.relations};
                movedObject = null;
                bindingObjects = null;
                ctx.relations = null;
                // TODO: remove temporary of ctx.movedObject

            },

            cancel: function (ctx, evt) {
                LOG.for("createpoint-tool-state") && LOG.info("Cancel.");
                if(movedObject) movedObject.dispose();
                for(let r of ctx.relations)  r.dispose();
                movedObject = null;
                bindingObjects = null;
                ctx.relations = null;
            },

            updateCoordinateV: function (ctx, evt) {
                movingDirection = Direction.VERTICAL;
                cabri.notifyFileDirty();
                const o = movedObject;
                if (o.dragAlongRay) {
                    o.dragAlongRay(evt.pointerInfo.pickInfo.ray,
                        evt.pointerInfo.pickedPoint, true);
                    updateCoords(movedObject);
                }
            },

            updateCoordinateH: function (ctx, evt) {
                movingDirection = Direction.HORIZONTAL;
                cabri.notifyFileDirty();
                if (movedObject.dragAlongRay) {
                    movedObject.dragAlongRay(evt.pointerInfo.pickInfo.ray,
                        evt.pointerInfo.pickedPoint, false);
                    updateCoords(movedObject);
                }
            },

            checkPermanent: (ctx, evt) => {
                if (evt.doubleClicked) {
                    permanent = true;
                }
            },
            initGestures: (ctxt, evt) => {
                // needed because the first gesture-handler as imported is
                // going to be empty.
                gesture = cabri.gestureHandler;
            },
        },

        guards: {
            noMouse: () => {
                return !gesture.hasMouse || !gesture.isFocussed;
            },
            mouseIsOnObject: () => {
                return gesture.hasMouse && gesture.isFocussed &&
                    gesture.touchedGeomObject;
            },
            isPermanent: (ctx) => {
                return permanent;
            },
            isNotPermanent: (ctx) => {
                return !permanent;
            },
        },
    },
);
